import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePutAccountProfile = () => {
    const navigate = useNavigate()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const clickEvent = (uploadPath) => {
        fetchRequest("PUT", "/account/profile-img", {
            "profile_img": uploadPath
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                window.location.reload()
                break
            case 400:
                setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("계정 데이터가 존재하지 않습니다.")
                break
        }
    }, [fetchResult])

    return [clickEvent]
}

export default usePutAccountProfile